/**
 * Event helper
 */
export const eventHelper = (overlayTrigger) => {

    const links = document.getElementsByTagName('a');
    for (let i = 0; i < links.length; i++) {
        const link = links[i] as any;
        const { dataset, isOverlaySet } = link;
        if (!isOverlaySet && dataset.action === 'overlay') {
            link.addEventListener('click', (e) => eList(e, link, overlayTrigger));
            link.isOverlaySet = true;
        }
    }

    return null;
};

/* istanbul ignore next */
const eList = (e, linkList, overlayTrigger) => {
    e.preventDefault();
    e.stopImmediatePropagation();
    const target = e.currentTarget as HTMLInputElement;
    const trackingName = target.textContent === 'Tarifdetails' ? 'tariff details' : target.dataset.trackingName;
    // @ts-ignore
    const tarLink = target.href;

    overlayTrigger(tarLink, trackingName);
};
